import styled from "styled-components/macro"
import { Card, Table } from "@humanpredictiveintelligence/myqvt-library"

export const Container = styled(Card)`
  display: flex;
  flex-direction: column;
  padding: 8px 24px;
`

export const TablePagination = styled.div`
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 2rem;
`

export const AutoDiagStatsTable = styled(Table)`
`
